import React from "react";
import Circle from "./Circle";
import "./eachcard.css";
import { useHistory } from "react-router-dom";

const EachCard = ({ show }) => {
  console.log(show);
  const history = useHistory();
  const entering = (e) => {
    console.log(e);
  };
  const exiting = () => {};

  const handleViewDetails = () => {
    if (show.goto.startsWith("http")) {
      // If the link is external
      window.location.href = show.goto;
    } else {
      // If the link is internal
      history.replace(show.goto);
    }
  };
  return (
    <div className="eachBox" onMouseEnter={entering} onMouseLeave={exiting}>
      <div className="eachBoxTop">
        <Circle image={show?.image} />
        {/* <div className="each1"></div> */}
        <div className="each2"> {show?.title}</div>
      </div>
      <div className="eachBoxBottom">
        <div className="cardText">{show?.description}</div>
        <div className="buttonview" onClick={handleViewDetails}>
          View details
        </div>
      </div>
    </div>
  );
};

export default EachCard;
